// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__xlC2Y","nav":"Header_nav__3rGcy"};